import { ErrorHandler, Injectable } from '@angular/core';
import { ToastService } from './toast.service';

type RepoErrorCause = {
  code: 'REPO_CONNECTION_FAILED' | 'REPO_NOT_FOUND' | 'REPO_MISMATCH' | 'SERVER_URL_NOT_SET' | string;
  provided?: string;
  fetched?: string;
};

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private toast: ToastService) {}

  handleError(error: Error): void {
    console.error('Unhandled error occurred: %o', error);

    let errorMessage = 'An unexpected error occurred.';

    let dontShowError: boolean = false;
    const cause = error.cause as RepoErrorCause | undefined;

    if (cause?.code) {
      switch (cause.code) {
        case 'REPO_CONNECTION_FAILED':
          errorMessage = 'Failed to connect to the study.';
          break;
        case 'REPO_NOT_FOUND':
          errorMessage = 'Study not found. Please check the URL';
          break;
        case 'REPO_MISMATCH':
          errorMessage = `Study mismatch: expected ${cause.provided ?? 'unknown'}, but got ${cause.fetched ?? 'unknown'}. Please provide the correct server URL for ${cause.fetched ?? 'unknown'}.`;
          break;
        case 'SERVER_URL_NOT_SET':
          errorMessage = 'Please connect to a study.';
          break;
        case 'FETCH_USER_ERROR':
          dontShowError = true;
          // errorMessage = 'Please sign in again.';
          break;
        case 'INVALID_NODE_PATH':
          errorMessage = "Invalid node path. Please check the path and try again.";
          break;
        case 'MISSING_PROTOCOL_PATH':
          errorMessage = 'Protocol file path is required for USDM workflow';
          break;

        case 'OSB_Server_URL':
          errorMessage = 'OSB Server URL is required for USDM workflow';
          break;

        case 'Protocol_File_Selection':
          errorMessage = 'Protocol file selection is required for USDM workflow';
          break;

        case 'TOO_MANY_AI_FAILURES':
          errorMessage = 'AI service limit reached. Please contact admin for assistance.';
          break;
        case 'USDM_WORKFLOW_ERROR':
          errorMessage = 'An error occurred during the USDM workflow.\n' + error.message;
          break;
        case 'FETCH_OSB_STUDIES_ERROR':
          errorMessage = 'Failed to fetch OSB studies. Please contact admin for assistance.';
          break;
        default:
          errorMessage = `Error: ${cause.code}`;
          break;
      }
    }
    if (!dontShowError) {
      this.toast.showError(errorMessage);
    }
    // this.loggingService.logError(error);
  }
}
